import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const getPayoutListById = (data, callback, errorCallBack) => {

    return async (dispatch) => {

        formDataCommonFunction(data, apiConstants.PAYMENT_GATEWAY.GET_PAYOUT_LIST_BY_ID)
            .then((response) => {
                callback && callback(response)

            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 